import {
  SidebarInset,
  SidebarProvider,

} from "@/components/ui/sidebar";

interface DefaultLayoutProps {
    children: React.ReactNode;
}

export default function DefaultLayout({ children }: DefaultLayoutProps) {
  return (
    <SidebarProvider>
      <SidebarInset>
        {children}
      </SidebarInset>
    </SidebarProvider>
  );
}
